import styled from '@emotion/styled'
import * as v from '../../../variables/styles'

export const MainBodyContainer = styled.div((props)=>({
  display: 'flex',
  flex: 1,
  backgroundColor: `${v.bgGray}`,
  flexDirection: 'column',
  padding: '20px 20px 20px 20px',
  maxWidth: '100%',

  '.emptyContent': {
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },

  '.bp3-progress-bar': {
    width: '80%',
  },

  '.bp3-progress-meter': {
    backgroundColor: `${v.ezMainColor} !important`,
  },

  'div.priorityUrgent': {
    marginLeft:'0.5rem',
    display:'flex',
    justifyContent:'center',
    background: '#FF0000',
    borderRadius: '2px',
    color: '#FFF',
    fontWeight: 'bold',
    padding: '2px 5px',
  },

  '&>div>div.ui.menu': { 
    overflowX: 'scroll' 
  },

  '@media only screen and (min-width: 600px)': {
    padding: '20px 20px 20px 20px',

    '&>div>div.ui.menu': { 
      overflowX: 'unset' 
    },
  },

  '@media only screen and (min-width: 769px)': {
    padding: '20px 40px 20px 20px',

    '&>div>div.ui.menu': { 
      overflowX: 'unset' 
    },
  },
}))

export const Heading = styled.div((props)=>({
  width: '100%',
  fontFamily: 'IBM Plex Sans Thai',
  color: `${v.ezBackColor}`,
  fontSize: '1.875rem',
  fontWeight: 'bold',
  borderBottom: '1.5px dashed #CCCCCC',
  paddingBottom: '10px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  alignItems: 'normal',

  '.accessoriesContent': {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
  }, 

  '.titleContent':{
    display:'flex',
    flexDirection:'column',
  },

  '.titleText': {
    fontSize: '23px',
    display:'flex',
    alignItems:'flex-start',
    flexDirection: 'column',
  },

  '@media only screen and (min-width: 600px)': {
    padding: '0px 0px 10px 0px',
    flexDirection: 'row',
    alignItems: 'normal',

    '.titleText': {
      alignItems:'center',
      flexDirection: 'row',
    },
  },

  '@media only screen and (min-width: 769px)': {
    padding: '20px 40px 20px 20px',
    flexDirection: 'row',
    alignItems: 'flex-start',

    '.titleText': {
      alignItems:'center',
      flexDirection: 'row',
    },
  },
}))